import { getServiceNotificationPreview } from '@/modules/Service/services'
import { ModalProps } from '@/types/shared'
import { Dialog } from 'vnetwork-ui'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'

import { QUERY_KEYS } from '@/constants/reactQueryKeys'

export interface PreviewServiceNotificationModalProps extends ModalProps {
    serviceID: number
    notificationID: number
    mailerID: number
}

const PreviewServiceNotification: React.FC<
    PreviewServiceNotificationModalProps
> = ({ serviceID, notificationID, mailerID, onClose, open }) => {
    console.log(serviceID, notificationID)
    const { data, renderState } = useQueryWithHandler({
        queryKey: [
            QUERY_KEYS.SERVICE_NOTIFICATION_PREVIEW,
            serviceID,
            notificationID,
        ],
        queryFn: () =>
            getServiceNotificationPreview({
                serviceID: serviceID,
                notificationID: notificationID,
                mailerID: mailerID,
            }),
    })

    const stateComponent = renderState()

    return (
        <Dialog onClose={onClose} open={open} maxWidth="lg">
            {stateComponent ? (
                stateComponent
            ) : data ? (
                <div dangerouslySetInnerHTML={{ __html: data }} />
            ) : null}
        </Dialog>
    )
}

export default PreviewServiceNotification
